import * as signalR from "@microsoft/signalr";
import apiDomainService from "../../../services/apiDomainService";

let connection = null;
let starting = null;
const peers = new Map();

export function hubBaseUrl() {
  return apiDomainService.replaceSubdomain().replace(/\/api\/?$/, "");
}

export function connectCommunicationHub(token, handlers) {
  if (connection && connection.state === signalR.HubConnectionState.Connected) {
    return Promise.resolve(connection);
  }
  if (starting) return starting;

  connection = new signalR.HubConnectionBuilder()
    .withUrl(`${hubBaseUrl()}/hubs/communication`, { accessTokenFactory: () => token })
    .withAutomaticReconnect()
    .build();

  const events = [
    "ReceiveMessage", "MessageDelivered", "MessageRead", "UserTyping", "UserStoppedTyping",
    "IncomingCall", "CallAccepted", "CallRejected", "CallEnded", "ParticipantJoined", "ParticipantLeft",
    "ReceiveOffer", "ReceiveAnswer", "ReceiveIceCandidate", "MediaStateChanged", "FeatureDisabled", "SessionRevoked",
  ];
  events.forEach((name) => {
    connection.on(name, (payload) => handlers[name] && handlers[name](payload));
  });

  starting = connection.start()
    .then(() => connection)
    .catch((error) => {
      connection = null;
      throw error;
    })
    .finally(() => {
      starting = null;
    });
  return starting;
}

export async function invokeHub(method, ...args) {
  try {
    if (starting) await starting;
    if (!connection || connection.state !== signalR.HubConnectionState.Connected) return false;
    await connection.invoke(method, ...args);
    return true;
  } catch (error) {
    console.warn("Communication hub call skipped", error);
    return false;
  }
}

export function getCommunicationConnection() {
  return connection;
}

export async function stopCommunicationHub() {
  peers.forEach((peer) => {
    try { peer.destroy(); } catch (_) { /* already closed */ }
  });
  peers.clear();
  if (connection) {
    try { await connection.stop(); } catch (_) { /* socket already closed */ }
    connection = null;
  }
}

export function trackPeer(userId, peer) {
  peers.set(userId, peer);
}

export function peerFor(userId) {
  return peers.get(userId);
}

export function dropPeer(userId) {
  const peer = peers.get(userId);
  if (peer) {
    try { peer.destroy(); } catch (_) { /* already closed */ }
    peers.delete(userId);
  }
}
